import { ExperimentationActions, UpdateExperimentationTogglePayload } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const UpdateExperimentationToggle = createAction<
  ExperimentationActions.UpdateToggle,
  UpdateExperimentationTogglePayload
>(ExperimentationActions.UpdateToggle, props<UpdateExperimentationTogglePayload>());
